
export enum WorkloadReportType {
    WORKLOAD     = 'workload',
    AVAILABILITY = 'availability',
}

export enum WorkloadDisplay {
    HOUR    = 'hour',
    PERCENT = 'percent',
}

export enum WorkloadSummaryBy {
    WORK_HOURS    = 'summary_hours',
    TASK_COUNT    = 'summary_tasks',
    SP            = 'summary_story_points'
}

export enum WorkloadReportGroupBy {
    PROJECT      = 'project',
    ASSIGNED_TO  = 'assigned-to',
}

export enum WorkloadReportTypeView {

    DAILY       = 'daily',
    WEEKLY      = 'weekly',
    MONTHLY     = 'monthly'
}


export const InitialShowColumnOption = [
    {
        label: "Show total",
        value: true
    },
    {
        label: 'Color coding',
        value: false
    }
]
